import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLaptopAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99905 18H13.9991M7.19905 3H16.7991C17.9192 3 18.4792 3 18.907 3.21799C19.2834 3.40973 19.5893 3.71569 19.7811 4.09202C19.9991 4.51984 19.9991 5.0799 19.9991 6.2V11.8C19.9991 12.9201 19.9991 13.4802 19.7811 13.908C19.5893 14.2843 19.2834 14.5903 18.907 14.782C18.4792 15 17.9192 15 16.7991 15H7.19905C6.07895 15 5.51889 15 5.09107 14.782C4.71475 14.5903 4.40878 14.2843 4.21704 13.908C3.99905 13.4802 3.99905 12.9201 3.99905 11.8V6.2C3.99905 5.0799 3.99905 4.51984 4.21704 4.09202C4.40878 3.71569 4.71475 3.40973 5.09107 3.21799C5.51889 3 6.07895 3 7.19905 3ZM4.5879 21H19.4102C20.2674 21 20.696 21 20.9542 20.8195C21.1796 20.6618 21.3301 20.4183 21.3703 20.1462C21.4163 19.8345 21.2246 19.4512 20.8413 18.6845L20.3257 17.6534C19.8441 16.6902 19.6034 16.2086 19.2441 15.8567C18.9264 15.5456 18.5435 15.309 18.1232 15.164C17.6478 15 17.1094 15 16.0325 15H7.96561C6.88874 15 6.3503 15 5.87494 15.164C5.45457 15.309 5.07168 15.5456 4.754 15.8567C4.39475 16.2086 4.15396 16.6902 3.67236 17.6534L3.15682 18.6845C2.77346 19.4512 2.58178 19.8345 2.62782 20.1462C2.66803 20.4183 2.81854 20.6618 3.04394 20.8195C3.30208 21 3.73069 21 4.5879 21Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLaptopAlt;
